<div class="content" role="main">

<img src="https://www.xeotek.com/wp-content/uploads/2020/04/Mailbox@01x.png" alt="A confirmation mail is on the way." style="width: 260px" />
  <h1>Confirmation mail is on it's way...</h1>
<span class="subtopic">
  You will shortly receive a mail with a confirmation link to the specified mail address. In the meantime, you can read our "Get Started" guide to get yourself familiar with the application.
</span>

  <p style="margin: 40px 0 50px; font-size: 15px">Still waiting? Check your SPAM folder as well, or <a target="_blank" href="https://support.xeotek.com/hc/en-us/requests/new">contact us</a>.</p>


  <h2>Next steps</h2>
  <p style="text-align: center;" class="steps"><b>1.</b><strong>Confirm mail:</strong> Click on the confirmation link in the confirmation email you have just received. Please also check your SPAM folder. <br/>&nbsp;
    <br/><b>2.</b><strong>Get your credentials: </strong>  Once you have confirmed your e-mail address, you will receive an email with your team id and secret. <br/>&nbsp;<br/>
    <b>3.</b><strong>Install KaDeck Web:</strong>  Install KaDeck Web from Docker Hub, as Helm chart or directly as Docker image and set your team id and the secret.</p>
  <app-onboarding></app-onboarding>
</div>
